import { CommonModule } from '@angular/common';
import {ChangeDetectionStrategy, Component, Input, OnInit} from '@angular/core';
import {ControlValueAccessor, FormsModule, ReactiveFormsModule, UntypedFormControl} from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatRadioModule } from '@angular/material/radio';

export class RadioBtn {
  value: any;
  text: string;
  hint: string;
  disabled: boolean;
  checked: boolean;
}

const ANGULAR_MATERIAL = [MatIconModule, MatRadioModule, MatInputModule];
// const PRIME_NG = [DropdownModule];
// const STANDALONE_COMPONENT = [DialogHeaderComponent, ButtonsComponent];

@Component({
  selector: 'terra-radio-buttons',
  templateUrl: './radio-buttons.component.html',
  styleUrls: ['./radio-buttons.component.scss'],
  standalone: true,
  imports: [CommonModule,
    FormsModule,
    ReactiveFormsModule,
    ...ANGULAR_MATERIAL],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class RadioButtonsComponent implements OnInit  {
  @Input() control: UntypedFormControl;
  @Input() details: RadioBtn[];

  constructor() { }

  ngOnInit(): void {
  }
}
